"use strict";
var nullComponentIDsRegistry = {};
function isNullComponentID(id) {
  return !!nullComponentIDsRegistry[id];
}
function registerNullComponentID(id) {
  nullComponentIDsRegistry[id] = true;
}
function deregisterNullComponentID(id) {
  delete nullComponentIDsRegistry[id];
}
var ReactEmptyComponentRegistry = {
  isNullComponentID,
  registerNullComponentID,
  deregisterNullComponentID
};
module.exports = ReactEmptyComponentRegistry;
